import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';

const propTypes = {
  classes: PropTypes.shape({}).isRequired,
  openForm: PropTypes.func.isRequired,
  setRef: PropTypes.func.isRequired,
  icon: PropTypes.node.isRequired,
  disabled: PropTypes.bool.isRequired,
  tooltip: PropTypes.string,
};

const defaultProps = {
  tooltip: '',
};

export function UnstyledFormToggleButton({ classes, openForm, setRef, icon, disabled, tooltip }) {
  const theButton = (
    <React.Fragment>
      {/* eslint-disable-next-line max-len */}
      <Button
        buttonRef={setRef}
        hover-override="darkPurple"
        className={classes.addButton}
        onClick={openForm}
        disabled={disabled}
      >
        <div className={classes.iconContainer}>{icon}</div>
      </Button>
    </React.Fragment>
  );

  let formattedButton;
  if (disabled) {
    formattedButton = (
      <Tooltip
        title="You do not have the required access for this resource. Contact your organization owner."
        classes={{ tooltip: classes.tooltip }}
      >
        <span>{theButton}</span>
      </Tooltip>
    );
  } else if (tooltip) {
    formattedButton = (
      <Tooltip placement="left" title={tooltip} classes={{ tooltip: classes.tooltip }}>
        <span>{theButton}</span>
      </Tooltip>
    );
  } else {
    formattedButton = theButton;
  }

  return <React.Fragment>{formattedButton}</React.Fragment>;
}

UnstyledFormToggleButton.propTypes = propTypes;

const styles = (theme) => ({
  iconContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',

    '& :first-child': {
      width: '40px',
      height: '40px',
      padding: '7px',
      boxShadow: 'none',
      fontSize: '2.5em',
      borderRadius: '50%',
      color: theme.customColors.white,
      background: theme.customColors.darkPurple,
      '&[disabled]': {
        background: 'rgba(77, 0, 66, 0.26)',
        '& svg': {
          background: 'rgba(77, 0, 66, 0.26)',
        },
      },
    },
    '&[disabled]': {
      background: 'rgba(77, 0, 66, 0.26)',
    },
  },
  iconLabel: {
    paddingTop: '0.25em',
    width: '100%',
  },
  addButton: {
    '&[disabled]': {
      '& span div svg': {
        background: 'rgba(77, 0, 66, 0.26)',
      },
      color: theme.customColors.white,
      background: 'rgba(77, 0, 66, 0.26)',
    },
    '&[hover-override~=darkPurple]': {
      color: theme.customColors.black,
      background: 'unset!important',
      padding: theme.spacing(1),
      minWidth: 'unset',
    },
  },
  addButtonLabel: {
    flexGrow: 3,
  },
});

UnstyledFormToggleButton.defaultProps = defaultProps;

export default withStyles(styles)(UnstyledFormToggleButton);
